import * as React from 'react';

export interface ArtificialInteligenceIllustrationProps {
  color: string;
}

export default function ArtificialInteligenceIllustration(
  props: ArtificialInteligenceIllustrationProps
) {
  return (
    <svg
      id="dd753f21-6b71-4d24-98dc-8d672633fdb2"
      data-name="Layer 1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1028.53 752.52"
    >
      <defs>
        <linearGradient
          id="b417a2e5-779f-434a-8a9b-5b809751130b"
          x1="493.91"
          y1="571.16"
          x2="493.91"
          y2="526.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
          <stop offset="1" stopColor="gray" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="04db0182-19cc-4c2e-a103-750e5424fcaf"
          x1="579.64"
          y1="682.92"
          x2="579.64"
          y2="218.06"
          xlinkHref="#b417a2e5-779f-434a-8a9b-5b809751130b"
        />
        <linearGradient
          id="497b2842-48f9-46b6-a092-cc1e43f49418"
          x1="448.98"
          y1="716.3"
          x2="448.98"
          y2="571.17"
          xlinkHref="#b417a2e5-779f-434a-8a9b-5b809751130b"
        />
        <linearGradient
          id="fadd9628-c3f0-4493-ac03-d18d51c12264"
          x1="533.65"
          y1="716.3"
          x2="533.65"
          y2="571.17"
          xlinkHref="#b417a2e5-779f-434a-8a9b-5b809751130b"
        />
      </defs>
      <title>artificial_intelligence</title>
      <ellipse cx="512.26" cy="706.43" rx="256" ry="43" fill="#dee3f3" opacity="0.5" />
      <g opacity="0.45">
        <path
          d="M536.5,332.71a11.13,11.13,0,0,0,.1,1.44A11.1,11.1,0,0,1,536.5,332.71Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M665.42,301.82c0,.13,0,.25.06.38C665.46,302.07,665.44,301.95,665.42,301.82Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M665.15,300.55c0,.13.07.27.1.4C665.22,300.81,665.19,300.68,665.15,300.55Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M665.28,335.12c0,.22-.11.44-.17.65C665.18,335.56,665.23,335.34,665.28,335.12Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M665.46,334.07c0,.23-.06.47-.11.7C665.4,334.54,665.44,334.3,665.46,334.07Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M542.46,342.52a11.13,11.13,0,0,1-2.37-1.67A11.09,11.09,0,0,0,542.46,342.52Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M540,340.78a11.15,11.15,0,0,1-.94-1A11.11,11.11,0,0,0,540,340.78Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M730.25,552.17a11,11,0,0,0-.47-1.29A11,11,0,0,1,730.25,552.17Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M724.74,545.51a11.11,11.11,0,0,1,1.26.77A11.05,11.05,0,0,0,724.74,545.51Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M727.22,547.27a11.13,11.13,0,0,1,1.77,2.14A11.11,11.11,0,0,0,727.22,547.27Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M726,546.3a11.18,11.18,0,0,1,1.05.85A11.11,11.11,0,0,0,726,546.3Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M729.68,550.69a11,11,0,0,0-.55-1A11,11,0,0,1,729.68,550.69Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M730.55,553.54a11,11,0,0,0-.24-1.09A11,11,0,0,1,730.55,553.54Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M1064.2,492.88h-63.65a11.06,11.06,0,0,0,4.76-9.09V454.57a11.07,11.07,0,0,0-11.07-11.07H921a11.08,11.08,0,0,0,7.71-10.55V403.72a11.06,11.06,0,0,0-4.76-9.09h70.32a11.07,11.07,0,0,0,11.07-11.07V354.33a11.07,11.07,0,0,0-11.07-11.07H916a11.08,11.08,0,0,0,7.71-10.55V303.48a11.06,11.06,0,0,0-4.76-9.09h75.33a11.07,11.07,0,0,0,11.07-11.07V254.09A11.07,11.07,0,0,0,994.23,243H954.8a11.08,11.08,0,0,0,7.71-10.55V203.25a11.07,11.07,0,0,0-11.07-11.07H844.53a11.07,11.07,0,0,0-11.07,11.07,11.07,11.07,0,0,0-11.07-11.07H715.47a11.07,11.07,0,0,0-10,6.41,11.1,11.1,0,0,1,.21,2.16V230a11,11,0,0,1-1,4.65,11.05,11.05,0,0,0,3.85,6.42h27.46a11,11,0,0,1,7,2.51h12a11.08,11.08,0,0,0-7.71,10.55A11.1,11.1,0,0,0,747,252s0,.08,0,.12v29.22a11.06,11.06,0,0,1-.36,2.76,4,4,0,0,1,.48.61,11.16,11.16,0,0,0,.09-1.39,11,11,0,0,0,.19,1.91,3.27,3.27,0,0,1,.25,1.11,11.09,11.09,0,0,0,4.33,6.07h-9.52l.24-.19c-.88,0-1.78-.07-2.66-.08a2.46,2.46,0,0,1-.92-.19,11.06,11.06,0,0,1-3.18.47l-65.61,2a11.06,11.06,0,0,0-4.76,9.09v29.22a11.08,11.08,0,0,0,7.71,10.55l62.66.52a11.07,11.07,0,0,1,3.25.49,12.11,12.11,0,0,1,2.07.36l.16,0a11,11,0,0,0-1.91-.82h15.42a11.08,11.08,0,0,0-7.71,10.55,11.12,11.12,0,0,0-.17-1.92,2.46,2.46,0,0,1-.24.3,11.12,11.12,0,0,1,.21,2.14v29.22c0,1.36.2,1,.2-.52a11.06,11.06,0,0,0,4.76,9.09l39.09,1.25a11,11,0,0,1,3.92.73h9.41a11.12,11.12,0,0,0-3.83,4.68,11,11,0,0,1,1.57,5.66V434.2a11,11,0,0,1-.93,4.43,11.1,11.1,0,0,0,6.13,4.87H797.06a11,11,0,0,1-6,1.78H752.27a11.05,11.05,0,0,0-5.07,9.3c0-3.9-1.45,34.56-1.45,34.56,0,3.45,60.34,5,60.34,5a11,11,0,0,1,4.45.94,7.75,7.75,0,0,1,1.92-.16l-.06,0h9.52a11.06,11.06,0,0,0-4.76,9.09,11.09,11.09,0,0,0-.12-1.58c-.05.12-.11.24-.17.35a11.08,11.08,0,0,1,.29,2.48v28a11.07,11.07,0,0,0,11.07,11.07h-17a11,11,0,0,1-5.11,1.25H736.68a11.07,11.07,0,0,0-6,9.82v29.22a11.07,11.07,0,0,0,11.07,11.07H848.69a11.07,11.07,0,0,0,11.07-11.07,11.07,11.07,0,0,0,11.07,11.07H977.74a11.07,11.07,0,0,0,11.07-11.07V555.33a11.07,11.07,0,0,0-11.07-11.07h86.45a11.07,11.07,0,0,0,11.07-11.07V504A11.07,11.07,0,0,0,1064.2,492.88ZM799.37,294.39a11.06,11.06,0,0,0-4.76,9.09,11.06,11.06,0,0,0-4.76-9.09ZM786.9,343.26a11.08,11.08,0,0,0,7.71-10.55,11.08,11.08,0,0,0,7.71,10.55ZM825.74,243a11.08,11.08,0,0,0,7.71-10.55A11.08,11.08,0,0,0,841.16,243Zm34,312.31a11.07,11.07,0,0,0-11.07-11.07h22.15A11.07,11.07,0,0,0,859.76,555.33Zm11.73-62.45a11.06,11.06,0,0,0,4.76-9.09,11.06,11.06,0,0,0,4.76,9.09Zm4.76-38.32A11.08,11.08,0,0,0,868.55,444H884A11.08,11.08,0,0,0,876.25,454.57Zm-4.76-61.92a11.06,11.06,0,0,0,4.76-9.09,11.06,11.06,0,0,0,4.76,9.09Zm4.76-38.32a11.08,11.08,0,0,0-7.71-10.55H884A11.08,11.08,0,0,0,876.25,354.33Zm-4.76-61.92a11.06,11.06,0,0,0,4.76-9.09,11.06,11.06,0,0,0,4.76,9.09Zm4.76-38.32a11.08,11.08,0,0,0-7.71-10.55H884A11.08,11.08,0,0,0,876.25,254.09ZM951,494.86a11.06,11.06,0,0,0-4.76,9.09,11.06,11.06,0,0,0-4.76-9.09Zm-15.84,49.39a11.07,11.07,0,0,0,11.07-11.07,11.07,11.07,0,0,0,11.07,11.07Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path d="M747.2,483.79" transform="translate(-85.73 -73.74)" fill={props.color} />
        <path
          d="M730.71,555.33a11.14,11.14,0,0,0-.1-1.41A11.11,11.11,0,0,1,730.71,555.33Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M665.56,332.71c0,.35,0,.7-.05,1C665.54,333.4,665.56,333.06,665.56,332.71Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M536.63,334.36a11,11,0,0,0,.28,1.32A11,11,0,0,1,536.63,334.36Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M412.7,399.65a2.52,2.52,0,0,1-.47-.56,2.7,2.7,0,0,1-.31-.92,22.36,22.36,0,0,0,0,2.28,11,11,0,0,1,.51,3.27,11,11,0,0,1,.49-3.19,4.58,4.58,0,0,1-.23-.77S412.7,399.69,412.7,399.65Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M564.27,192.17H457.36a11.07,11.07,0,0,0-11.07,11.07,11.07,11.07,0,0,0-11.07-11.07H328.31a11.07,11.07,0,0,0-11.07,11.07v29.22A11.08,11.08,0,0,0,324.94,243H242.06A11.07,11.07,0,0,0,231,254.09v29.22a11.06,11.06,0,0,0,4.76,9.09H160.41a11.07,11.07,0,0,0-11.07,11.07v29.22a11.07,11.07,0,0,0,11.07,11.07h78.28A11.08,11.08,0,0,0,231,354.33v29.22a11.06,11.06,0,0,0,4.76,9.09H165.43a11.07,11.07,0,0,0-11.07,11.07v29.22A11.07,11.07,0,0,0,165.43,444h73.26A11.08,11.08,0,0,0,231,454.57v29.22a11.07,11.07,0,0,0,11.07,11.07h63.65a11.06,11.06,0,0,0-4.76,9.09v29.22A11.07,11.07,0,0,0,312,544.25H225.57a11.07,11.07,0,0,0-11.07,11.07v29.22a11.07,11.07,0,0,0,11.07,11.07H332.47a11.07,11.07,0,0,0,11.07-11.07,11.07,11.07,0,0,0,11.07,11.07H461.53a11.07,11.07,0,0,0,11.07-11.07V555.33a11.07,11.07,0,0,0-6-9.82H443.58a11,11,0,0,1-5.11-1.25H418.93A11.07,11.07,0,0,0,430,533.18c0,4.82,2.51-28,2.51-28a11.07,11.07,0,0,1,11.07-11.07l40.75-1.25a11.15,11.15,0,0,0,2.93-3,11,11,0,0,1-.88-4.29V456.34a11,11,0,0,1,1.83-6.09,11.11,11.11,0,0,0-4.2-5H426a11,11,0,0,1-6-1.78H404.75a11.08,11.08,0,0,0,7.71-10.55l-.39-29c0-1.31-.07-2.46-.12-3.49a11.09,11.09,0,0,0-4.25-5.82h9.52l-.21.16c5.4-.31,67.07-3.93,72.09-8a8.7,8.7,0,0,1-.07-2.32,11.1,11.1,0,0,1-.14-1.68V353.6c0-.36,0-.72.05-1.07a11.09,11.09,0,0,0-7.56-8.75h13.48a11,11,0,0,1,5.11-1.25h30.57a11.06,11.06,0,0,0,6-9.82V303.48a11.06,11.06,0,0,0-4.76-9.09l-31.78-2c-5.38,0-8.95-2-6.11,0h-9.52a11.05,11.05,0,0,0,4.76-9,11.12,11.12,0,0,1-.2-2V252.11s0,0,0-.07a11.09,11.09,0,0,0-7.51-8.5H493a11,11,0,0,1,7-2.51h71.31a11,11,0,0,0,4.07-8.57V203.25A11.07,11.07,0,0,0,564.27,192.17ZM283.16,294.39a11.06,11.06,0,0,0-4.76,9.09,11.06,11.06,0,0,0-4.76-9.09Zm-4.76,38.32a11.08,11.08,0,0,0,7.71,10.55H270.69A11.08,11.08,0,0,0,278.39,332.71Zm9.77,61.92a11.06,11.06,0,0,0-4.76,9.09,11.06,11.06,0,0,0-4.76-9.09ZM275.7,443.49a11.08,11.08,0,0,0,7.71-10.55,11.08,11.08,0,0,0,7.71,10.55Zm136.51-149.1a11.06,11.06,0,0,0-4.76,9.09,11.06,11.06,0,0,0-4.76-9.09ZM343.55,555.33a11.07,11.07,0,0,0-11.07-11.07h22.15A11.07,11.07,0,0,0,343.55,555.33Zm11.73-62.45a11.06,11.06,0,0,0,4.76-9.09,11.06,11.06,0,0,0,4.76,9.09ZM360,454.57A11.08,11.08,0,0,0,352.33,444h15.42A11.08,11.08,0,0,0,360,454.57Zm-4.76-61.92a11.06,11.06,0,0,0,4.76-9.09,11.06,11.06,0,0,0,4.76,9.09ZM360,354.33a11.08,11.08,0,0,0-7.71-10.55h15.42A11.08,11.08,0,0,0,360,354.33Zm-4.76-61.92a11.06,11.06,0,0,0,4.76-9.09,11.06,11.06,0,0,0,4.76,9.09ZM360,254.09a11.08,11.08,0,0,0-7.71-10.55h15.42A11.08,11.08,0,0,0,360,254.09Zm39.7,89.16a11.08,11.08,0,0,0,7.71-10.55,11.08,11.08,0,0,0,7.71,10.55ZM438.58,243a11.08,11.08,0,0,0,7.71-10.55A11.08,11.08,0,0,0,454,243Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path d="M540.14,295.29l.16-.14Z" transform="translate(-85.73 -73.74)" fill={props.color} />
        <path d="M539.41,296l-.16.18Z" transform="translate(-85.73 -73.74)" fill={props.color} />
        <path d="M538.48,297.18l.08-.11Z" transform="translate(-85.73 -73.74)" fill={props.color} />
        <path
          d="M537,335.9a11,11,0,0,0,.46,1.27A11,11,0,0,1,537,335.9Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M538.16,338.53a11.08,11.08,0,0,0,.82,1.14A11.06,11.06,0,0,1,538.16,338.53Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M537.5,337.28a11,11,0,0,0,.66,1.24A11,11,0,0,1,537.5,337.28Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M536.81,300.95c0-.14.07-.27.1-.4C536.87,300.68,536.84,300.81,536.81,300.95Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M537.18,299.7c0-.11.08-.22.12-.33C537.26,299.48,537.22,299.59,537.18,299.7Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path
          d="M536.58,302.2c0-.13,0-.26.06-.38C536.62,301.95,536.6,302.07,536.58,302.2Z"
          transform="translate(-85.73 -73.74)"
          fill={props.color}
        />
        <path d="M537.79,298.31l0,0Z" transform="translate(-85.73 -73.74)" fill={props.color} />
        <rect
          x="318.49"
          y="192.17"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(680.3 361.98) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="704.4"
          y="192.17"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1452.12 361.98) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="876.05"
          y="242.29"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1795.43 462.22) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="665.56"
          y="292.41"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1374.43 562.45) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="876.05"
          y="343.78"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1795.43 665.19) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="876.05"
          y="444.02"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1795.43 865.67) rotate(-180)"
          opacity="0.1"
        />
        <path
          d="M938.16,494.14H825.23a8.06,8.06,0,0,0-7.74,5.8,5.15,5.15,0,0,1-.09,1.36,5.71,5.71,0,0,1-.23.77s0,.09,0,.13v35.25a8.06,8.06,0,0,0,8.06,8.06H938.16a8.06,8.06,0,0,0,8.06-8.06V502.2A8.06,8.06,0,0,0,938.16,494.14Z"
          transform="translate(-85.73 -73.74)"
          opacity="0.1"
        />
        <rect
          x="730.71"
          y="544.25"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1504.74 1066.14) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="359.84"
          y="242.29"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(762.99 462.22) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="279.65"
          y="292.41"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(602.61 562.45) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="230.78"
          y="343.78"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(504.88 665.19) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="283.41"
          y="393.9"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(610.13 765.43) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="230.78"
          y="444.02"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(504.88 865.67) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="172.4"
          y="494.19"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(388.12 966.01) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="925.92"
          y="393.84"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1895.15 765.32) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="920.44"
          y="292.58"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(1884.2 562.8) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="985.21"
          y="543.45"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(2013.74 1064.54) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="85.73"
          y="544.36"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(214.79 1066.36) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="103.07"
          y="443.11"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(249.45 863.84) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="103.07"
          y="343.67"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(249.45 664.97) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="107.63"
          y="242.41"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(258.58 462.45) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="107.63"
          y="242.41"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(258.58 462.45) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="189.73"
          y="192.24"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(422.78 362.11) rotate(-180)"
          fill={props.color}
        />
        <rect
          x="302.2"
          y="494.14"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(647.72 965.9) rotate(-180)"
          opacity="0.1"
        />
        <rect
          x="214.49"
          y="544.25"
          width="129.05"
          height="51.37"
          rx="8.84"
          ry="8.84"
          transform="translate(472.31 1066.14) rotate(-180)"
          opacity="0.1"
        />
      </g>
      <circle cx="810.34" cy="28.92" r="28.92" fill={props.color} opacity="0.5" />
      <path
        d="M337.67,155.09h-6.88a4.82,4.82,0,0,0,0-9.63H275.06a4.82,4.82,0,1,0,0,9.63h6.88a4.82,4.82,0,0,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63H328a4.82,4.82,0,0,0,0-9.63h9.63a4.82,4.82,0,0,0,0-9.63Z"
        transform="translate(-85.73 -73.74)"
        fill="#dee3f3"
        opacity="0.5"
      />
      <path
        d="M892.4,99.18h-5.24a3.67,3.67,0,0,0,0-7.33H844.75a3.67,3.67,0,0,0,0,7.33H850a3.67,3.67,0,1,0,0,7.33h-7.33a3.67,3.67,0,0,0,0,7.33h42.42a3.67,3.67,0,1,0,0-7.33h7.33a3.67,3.67,0,1,0,0-7.33Z"
        transform="translate(-85.73 -73.74)"
        fill="#dee3f3"
        opacity="0.5"
      />
      <path
        d="M469.67,87.09h-6.88a4.82,4.82,0,1,0,0-9.63H407.06a4.82,4.82,0,1,0,0,9.63h6.88a4.82,4.82,0,0,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63H460a4.82,4.82,0,0,0,0-9.63h9.63a4.82,4.82,0,0,0,0-9.63Z"
        transform="translate(-85.73 -73.74)"
        fill="#dee3f3"
        opacity="0.5"
      />
      <polygon
        points="552.66 540.06 571.66 540.06 571.66 528.29 571.66 526.24 416.16 526.24 416.16 528.29 416.16 540.06 435.16 540.06 435.16 553.89 404.06 553.89 404.06 571.16 583.76 571.16 583.76 553.89 552.66 553.89 552.66 540.06"
        fill="url(#b417a2e5-779f-434a-8a9b-5b809751130b)"
      />
      <path
        d="M765.69,626.46h0c1.36-18.6.88-34.61-1-48.4-2.13-15.87-6.08-28.78-11.09-39.28-10-21-24.25-32.39-36.76-38.58a69.16,69.16,0,0,0-26.9-7.34,12.08,12.08,0,0,0-23.91-.05V461.75H600.37V444.47h88.48a10,10,0,0,0,10-10V343.9a10,10,0,0,0-10-10H655.26V244.62a13.48,13.48,0,0,0,7.93-12.28c0-.13,0-.26,0-.4s0-.26,0-.4a13.49,13.49,0,0,0-27,0c0,.13,0,.26,0,.4s0,.26,0,.4a13.48,13.48,0,0,0,7.14,11.9v89.65H518.81V244.24a13.48,13.48,0,0,0,7.14-11.9c0-.13,0-.26,0-.4s0-.26,0-.4a13.49,13.49,0,0,0-27,0c0,.13,0,.26,0,.4s0,.26,0,.4a13.48,13.48,0,0,0,7.93,12.28v89.26H470.43a10,10,0,0,0-10,10v90.56a10,10,0,0,0,10,10h88.48v17.28H493.25v25.46a12.07,12.07,0,0,0-2.61-4.35l-.29-.29a12.09,12.09,0,0,0-20.64,8.55v1.73s-12.42,0-27.27,7.35c-12.51,6.19-26.75,17.58-36.76,38.58-5,10.5-9,23.42-11.09,39.28-1.86,13.78-2.35,29.8-1,48.4-27.73,23,7,56.46,7,56.46,28.45,0,27.82-47.23,27.5-55.29h.14s-.08-.4-.2-1.14v0h0a176.9,176.9,0,0,1-1.71-39.9c.79-10.17,2.74-20.93,6.74-30.61a54.35,54.35,0,0,1,13.68-20.05,46.75,46.75,0,0,1,23-11.07v7.77a12.09,12.09,0,0,0,23.53,3.91V600H666V537.81a12.07,12.07,0,0,0,3.07,6.44l.33.35A12.09,12.09,0,0,0,690.08,536V524.92a46.62,46.62,0,0,1,22.46,11,54.35,54.35,0,0,1,13.68,20.05c4,9.69,5.94,20.44,6.74,30.61a176.9,176.9,0,0,1-1.71,39.9h0v0c-.12.74-.2,1.14-.2,1.14h.14c-.32,8.06-.95,55.29,27.5,55.29C758.69,682.92,793.42,649.48,765.69,626.46Z"
        transform="translate(-85.73 -73.74)"
        fill="url(#04db0182-19cc-4c2e-a103-750e5424fcaf)"
      />
      <polygon
        points="412.7 572.75 412.7 588.45 433.44 588.45 433.44 612.63 433.44 612.63 433.44 633.37 433.44 664.47 433.44 681.75 433.44 692.12 409.24 692.12 409.24 716.3 474.9 716.3 474.9 692.12 464.54 692.12 464.54 681.75 464.54 681.75 464.54 664.47 464.54 664.47 464.54 633.37 464.54 633.37 464.54 612.63 464.54 612.63 464.54 588.45 488.72 588.45 488.72 572.75 488.72 571.17 412.7 571.17 412.7 572.75"
        fill="url(#497b2842-48f9-46b6-a092-cc1e43f49418)"
      />
      <polygon
        points="495.64 572.75 495.64 588.45 526.74 588.45 526.74 612.63 526.74 612.63 526.74 633.37 526.74 664.47 526.74 681.75 526.74 692.12 502.55 692.12 502.55 716.3 568.21 716.3 568.21 692.12 557.84 692.12 557.84 681.75 557.84 664.47 557.84 633.37 557.84 612.63 557.84 612.63 557.84 588.45 571.66 588.45 571.66 572.75 571.66 571.17 495.64 571.17 495.64 572.75"
        fill="url(#fadd9628-c3f0-4493-ac03-d18d51c12264)"
      />
      <rect
        x="377.91"
        y="264.74"
        width="232.01"
        height="107.6"
        rx="12.97"
        ry="12.97"
        fill={props.color}
      />
      <rect x="396.4" y="355.83" width="195.02" height="2.02" opacity="0.1" />
      <rect x="396.4" y="281.55" width="195.02" height="73.97" opacity="0.3" />
      <circle cx="441.79" cy="320.08" r="26.9" opacity="0.1" />
      <circle cx="441.79" cy="318.54" r="26.9" fill="#dee3f3" />
      <circle cx="546.03" cy="320.08" r="26.9" opacity="0.1" />
      <circle cx="546.03" cy="318.54" r="26.9" fill="#dee3f3" />
      <rect x="473.73" y="372.34" width="40.35" height="23.54" fill={props.color} />
      <rect x="409.85" y="389.15" width="168.12" height="134.5" fill={props.color} />
      <polygon
        points="569.57 523.65 569.57 537.1 551.07 537.1 551.07 550.55 436.74 550.55 436.74 537.1 418.26 537.1 418.26 523.65 569.57 523.65"
        fill={props.color}
      />
      <polygon
        points="569.57 523.65 569.57 537.1 551.07 537.1 551.07 550.55 436.74 550.55 436.74 537.1 418.26 537.1 418.26 523.65 569.57 523.65"
        opacity="0.3"
      />
      <rect x="406.49" y="550.55" width="174.85" height="16.81" fill={props.color} />
      <rect x="414.89" y="567.37" width="73.97" height="16.81" fill={props.color} />
      <rect x="495.59" y="567.37" width="73.97" height="16.81" fill={props.color} />
      <rect x="411.53" y="685.05" width="63.89" height="23.54" fill={props.color} />
      <polygon
        points="435.07 607.71 435.07 627.89 435.07 658.15 435.07 674.96 435.07 685.05 465.33 685.05 465.33 674.96 465.33 658.15 465.33 627.89 465.33 607.71 465.33 584.17 435.07 584.17 435.07 607.71"
        fill={props.color}
      />
      <polygon
        points="525.85 584.17 525.85 607.71 525.85 627.89 525.85 658.15 525.85 674.96 525.85 685.05 556.12 685.05 556.12 674.96 556.12 658.15 556.12 627.89 556.12 607.71 556.12 584.17 525.85 584.17"
        fill={props.color}
      />
      <rect x="502.32" y="685.05" width="63.89" height="23.54" fill={props.color} />
      <path
        d="M496.22,491.47v40.35c0,.3,0,.61,0,.9a11.77,11.77,0,0,1-23.5-.9V491.47a11.76,11.76,0,0,1,20.08-8.32l.28.29a11.72,11.72,0,0,1,3.13,7.13C496.2,490.86,496.22,491.17,496.22,491.47Z"
        transform="translate(-85.73 -73.74)"
        fill={props.color}
      />
      <path
        d="M687.1,494.83v40.36A11.76,11.76,0,0,1,667,543.51l-.32-.34a11.73,11.73,0,0,1-3.13-8V494.83a11.77,11.77,0,0,1,23.54,0Z"
        transform="translate(-85.73 -73.74)"
        fill={props.color}
      />
      <path
        d="M472.68,493.15v31.1A45.49,45.49,0,0,0,450.33,535,52.88,52.88,0,0,0,437,554.54c-3.89,9.42-5.78,19.89-6.55,29.79a170.32,170.32,0,0,0,1.86,40H398.7c-1.43-18.59-1-34.53.88-48.23,2.08-15.44,5.92-28,10.79-38.22,9.74-20.43,23.6-31.52,35.77-37.54C460.6,493.15,472.68,493.15,472.68,493.15Z"
        transform="translate(-85.73 -73.74)"
        fill={props.color}
      />
      <path
        d="M405.43,678.09s-33.79-32.53-6.81-54.93h33.51S435.69,678.09,405.43,678.09Z"
        transform="translate(-85.73 -73.74)"
        fill={props.color}
      />
      <path
        d="M405.43,678.09s-33.79-32.53-6.81-54.93h33.51S435.69,678.09,405.43,678.09Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.3"
      />
      <rect x="436.75" y="409.33" width="114.32" height="87.42" opacity="0.3" />
      <rect x="435.07" y="584.17" width="30.26" height="23.54" opacity="0.3" />
      <rect x="435.07" y="627.89" width="30.26" height="30.26" opacity="0.3" />
      <rect x="435.07" y="674.96" width="30.26" height="10.09" opacity="0.3" />
      <rect x="525.85" y="584.17" width="30.26" height="23.54" opacity="0.3" />
      <rect x="525.85" y="627.89" width="30.26" height="30.26" opacity="0.3" />
      <rect x="525.85" y="674.96" width="30.26" height="10.09" opacity="0.3" />
      <path
        d="M472.68,493.15v31.1A45.49,45.49,0,0,0,450.33,535l-4.18-34.73C460.6,493.15,472.68,493.15,472.68,493.15Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.3"
      />
      <path
        d="M437,554.54c-3.89,9.42-5.78,19.89-6.55,29.79l-30.88-8.27c2.08-15.44,5.92-28,10.79-38.22Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.3"
      />
      <path
        d="M686.61,493.15v31.1A45.49,45.49,0,0,1,709,535a52.88,52.88,0,0,1,13.31,19.51c3.89,9.42,5.78,19.89,6.55,29.79a170.32,170.32,0,0,1-1.86,40h33.62c1.43-18.59,1-34.53-.88-48.23-2.08-15.44-5.92-28-10.79-38.22-9.74-20.43-23.6-31.52-35.77-37.54C698.69,493.15,686.61,493.15,686.61,493.15Z"
        transform="translate(-85.73 -73.74)"
        fill={props.color}
      />
      <path
        d="M753.86,678.09s33.79-32.53,6.81-54.93H727.15S723.6,678.09,753.86,678.09Z"
        transform="translate(-85.73 -73.74)"
        fill={props.color}
      />
      <path
        d="M753.86,678.09s33.79-32.53,6.81-54.93H727.15S723.6,678.09,753.86,678.09Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.3"
      />
      <path
        d="M686.61,493.15v31.1A45.49,45.49,0,0,1,709,535l4.18-34.73C698.69,493.15,686.61,493.15,686.61,493.15Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.3"
      />
      <path
        d="M722.27,554.54c3.89,9.42,5.78,19.89,6.55,29.79l30.88-8.27c-2.08-15.44-5.92-28-10.79-38.22Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.3"
      />
      <rect x="473.73" y="372.34" width="40.35" height="2.79" opacity="0.1" />
      <path
        d="M666.69,486.86v56.31a11.73,11.73,0,0,1-3.13-8V494.83A11.71,11.71,0,0,1,666.69,486.86Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.1"
      />
      <path
        d="M496.18,490.57v42.15a11.72,11.72,0,0,1-3.13,7.13V483.44A11.72,11.72,0,0,1,496.18,490.57Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.1"
      />
      <rect x="418.26" y="523.65" width="151.31" height="1.99" opacity="0.1" />
      <rect x="414.89" y="567.37" width="73.97" height="1.54" opacity="0.1" />
      <rect x="495.59" y="567.37" width="73.97" height="1.54" opacity="0.1" />
      <rect x="423.14" y="165.17" width="11.58" height="99.58" fill={props.color} />
      <rect x="555.91" y="165.17" width="11.58" height="99.58" fill={props.color} />
      <circle cx="428.55" cy="165.94" r="13.12" opacity="0.1" />
      <circle cx="428.55" cy="165.17" r="13.12" fill={props.color} />
      <circle cx="562.09" cy="165.94" r="13.12" opacity="0.1" />
      <circle cx="562.09" cy="165.17" r="13.12" fill={props.color} />
      <path
        d="M237.26,544s38.4,75.38,7.11,116.62,2.84,153.6,2.84,153.6"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#fc6681"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M248.63,520.48C248.63,535,238,546.8,238,546.8S227.3,535,227.3,520.48,238,494.17,238,494.17,248.63,506,248.63,520.48Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M257.17,544s-38.4,75.38-7.11,116.62-2.84,153.6-2.84,153.6"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#ffd037"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M245.79,520.48c0,14.53,10.67,26.31,10.67,26.31s10.67-11.78,10.67-26.31-10.67-26.31-10.67-26.31S245.79,506,245.79,520.48Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M272.81,544s38.4,75.38,7.11,116.62,2.84,153.6,2.84,153.6"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#fc6681"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M284.19,520.48c0,14.53-10.67,26.31-10.67,26.31S262.86,535,262.86,520.48s10.67-26.31,10.67-26.31S284.19,506,284.19,520.48Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M278.21,580.88c-10.07,10.47-25.93,11.57-25.93,11.57s.48-15.88,10.55-26.36,25.93-11.57,25.93-11.57S288.28,570.41,278.21,580.88Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M279.21,632.88c-10.07,10.47-25.93,11.57-25.93,11.57s.48-15.88,10.55-26.36,25.93-11.57,25.93-11.57S289.28,622.41,279.21,632.88Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M224.58,661.49c9.53,11,9.19,26.86,9.19,26.86s-15.78-1.9-25.3-12.87-9.19-26.86-9.19-26.86S215.05,650.52,224.58,661.49Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M233.42,550.59c12.11,8,16,23.43,16,23.43s-15.71,2.38-27.82-5.64-16-23.43-16-23.43S221.3,542.57,233.42,550.59Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M292.72,544s-38.4,75.38-7.11,116.62-2.84,153.6-2.84,153.6"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#ffd037"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M281.35,520.48C281.35,535,292,546.8,292,546.8s10.67-11.78,10.67-26.31S292,494.17,292,494.17,281.35,506,281.35,520.48Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M284.41,582c-10.2,10.35-10.87,26.23-10.87,26.23s15.87-.9,26.07-11.25,10.87-26.23,10.87-26.23S294.61,571.65,284.41,582Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M304.41,654c-10.2,10.35-10.87,26.23-10.87,26.23s15.87-.9,26.07-11.25,10.87-26.23,10.87-26.23S314.61,643.65,304.41,654Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M275,638.17s23.12-36.44,55.56-37.22"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#ffd037"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M257,616.17S233.87,579.74,201.43,579"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#fc6681"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M254,668.17s23.12-36.44,55.56-37.22"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#ffd037"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <circle cx="243.76" cy="526.93" r="6" fill="#ffd037" />
      <circle cx="116.26" cy="505.43" r="6" fill="#fc6681" />
      <path
        d="M271,680.17S247.87,643.74,215.43,643"
        transform="translate(-85.73 -73.74)"
        fill="none"
        stroke="#fc6681"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <circle cx="130.26" cy="569.43" r="6" fill="#fc6681" />
      <circle cx="224.26" cy="557.43" r="6" fill="#ffd037" />
      <path
        d="M398.76,770.41s-55.7-11.14-70.56-26-81.7-40.85-89.13-22.28S138.81,803.83,201.94,815s148.54,14.85,167.11,7.43S398.76,770.41,398.76,770.41Z"
        transform="translate(-85.73 -73.74)"
        fill="#a8a8a8"
      />
      <path
        d="M201.94,808.07c63.13,11.14,148.54,14.85,167.11,7.43,14.14-5.66,24-32.83,27.85-45.48l1.86.39s-11.14,44.56-29.71,52-104,3.71-167.11-7.43c-18.22-3.22-23.43-10.77-21.47-20.33C182,800.88,188.38,805.68,201.94,808.07Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.2"
      />
      <path
        d="M1000.38,557.26s13.35,17.45-6.16,43.81-35.59,48.6-29.09,65c0,0,29.43-48.94,53.39-49.62S1026.74,586.69,1000.38,557.26Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M1000.38,557.26a21.62,21.62,0,0,1,2.73,5.47c23.37,27.46,35.83,53.09,13.36,53.73-20.93.6-46,38-52,47.47a20.28,20.28,0,0,0,.71,2.15s29.43-48.94,53.39-49.62S1026.74,586.69,1000.38,557.26Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.1"
      />
      <path
        d="M1025.2,579.5c0,6.14-.69,11.12-1.54,11.12s-1.54-5-1.54-11.12.86-3.25,1.71-3.25S1025.2,573.36,1025.2,579.5Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M1033.71,586.84c-5.39,2.94-10.1,4.72-10.5,4s3.64-3.74,9-6.68,3.27-.8,3.67-.05S1039.1,583.9,1033.71,586.84Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M929.89,557.26s-13.35,17.45,6.16,43.81,35.59,48.6,29.09,65c0,0-29.43-48.94-53.39-49.62S903.53,586.69,929.89,557.26Z"
        transform="translate(-85.73 -73.74)"
        fill="#fc6681"
      />
      <path
        d="M929.89,557.26a21.62,21.62,0,0,0-2.73,5.47c-23.37,27.46-35.83,53.09-13.36,53.73,20.93.6,46,38,52,47.47a20.28,20.28,0,0,1-.71,2.15s-29.43-48.94-53.39-49.62S903.53,586.69,929.89,557.26Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.1"
      />
      <path
        d="M905.07,579.5c0,6.14.69,11.12,1.54,11.12s1.54-5,1.54-11.12-.86-3.25-1.71-3.25S905.07,573.36,905.07,579.5Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M896.56,586.84c5.39,2.94,10.1,4.72,10.5,4s-3.64-3.74-9-6.68-3.27-.8-3.67-.05S891.17,583.9,896.56,586.84Z"
        transform="translate(-85.73 -73.74)"
        fill="#ffd037"
      />
      <path
        d="M909.32,663.8s37.32-1.15,48.56-9.16,57.4-17.57,60.19-4.73,56.08,63.88,13.95,64.22-97.89-6.56-109.12-13.4S909.32,663.8,909.32,663.8Z"
        transform="translate(-85.73 -73.74)"
        fill="#a8a8a8"
      />
      <path
        d="M1032.78,709.67c-42.13.34-97.89-6.56-109.12-13.4-8.55-5.21-12-23.89-13.09-32.51l-1.25,0s2.36,30.1,13.59,36.93,67,13.74,109.12,13.4c12.16-.1,16.36-4.42,16.13-10.83C1046.47,707.18,1041.83,709.59,1032.78,709.67Z"
        transform="translate(-85.73 -73.74)"
        opacity="0.2"
      />
    </svg>
  );
}
